import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import {exhibitionlist, api} from '../../apis/urls'
import Loader from '../../common-components/loader'
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import moment from "moment";
import { decode } from "html-entities";

const Exhibitionlist =()=> {

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing({page:page?page-1:0});
        });
    }, []);

    const page = new URLSearchParams(useLocation().search).get('page')

    const navigate = useNavigate();

    const Listing = ({page, size, search, status}) => {

        let pageQuery = page ? page : 0;
        let sizeQuery = size ? size : 10;
        let searchQuery = search ? search : '';
        let statusQuery = status ? status : '';

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: `${exhibitionlist}?page=${pageQuery}&size=${sizeQuery}&search=${searchQuery}&status=${statusQuery}`,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {

            if(res.data.message === "Success"){            
                setexhibitionList(res.data.data.items);
                setCurrentpage(res.data.data.currentPage)
                setTotalPages(res.data.data.totalPages)
                setTotalItems(res.data.data.totalItems)
            }else{
                setexhibitionList(false)
            }
            setLoader(false)
        });
    }

    const [loader,setLoader] = useState(false);
    const [exhibitiontList, setexhibitionList] = useState([]);
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);
    const [searchData, setSearchData] = useState('');
    const [statusData, setStatusData] = useState('');

    let counts = 0;
    if(exhibitiontList)
    {
        counts = exhibitiontList.length;
    }


    const refreshList = () => {
        setexhibitionList(null);
    };


    const handlePageClick = (event) => { 
        console.log('event',event)
        navigate(`/exhibition?page=${event.selected+1}`)
        Listing({page:event.selected, search: searchData, status: statusData});
    };
 

    const statusChange = (id) => { 

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: `${exhibitionlist}/publish/${id}`,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.patch('').then(res => {

            Listing({page:page?page-1:0, search: searchData, status: statusData});

        }).catch(e => {
            console.log('errorshw',e);
        });
   
    };

    const handleChangeSearch = (e) => {
        
        if(e.target.name === 'search'){
            setSearchData(e.target.value)
            Listing({page:0, search: e.target.value, status: statusData});
        }else{
            setStatusData(e.target.value)
            Listing({page:0, search: searchData, status: e.target.value});
        }

        navigate(`/exhibition`)


    }

    let sl =1;
    return(
        <div>
        <aside class="right-side areas">
			<div class="content-area dash-contentss">
                <div class="page-title-wrpr">
                <div class="page-title-left-column">
                    <i class="icon-library1"></i>
                    <h2 class="page-title">Exhibitor List</h2>
                </div>

                <div class="page-rightside-action-column">
                    <div class="input-groups mt-3 mb-3 search-grps">
                    <input type="text" 
                    name="search"
                    class="form-controls search-bar asso-search"             
                    onChange={(e) => {handleChangeSearch(e)}}   
                    placeholder="Search" />
                    <button  class="btn btn-search icon-search assosearch-btn"></button>
                    </div>
                    <Link to="/add_exhibition" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Event"><i class="icon-add"></i><span>Add New Exhibitor</span> </Link>
                </div>

            </div>
             
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item active" aria-current="page">Exhibitor List</li>
              </ol>
            </nav>

            {exhibitiontList?
            <div class="number-of">
                Displaying 1-{counts} of {totalItems} results.
            </div>:null
            }



            <div class="faculty-list-wrpr list-wrpr">
            {exhibitiontList?(
            exhibitiontList?.map((item, index) =>
                <div class="list faculty"  style={{opacity: item?.publish === 'UNPUBLISHED' && 0.7}}>
                    <div class="row">
                        <div class="col-md-1">
                            <div class="update-date">
                                <span class="date-wrpr">{(index+1)+currentpage*10}</span>
                                <span class="desig">Sl.No</span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="faculty-user">
                                <span class="desig">Exhibitor Name</span>
                                <span class="date-wrpr">{decode(item.name)}</span>

                            </div>     
                        </div>
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">{item.year}</span>
                                <span class="desig">Year</span>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">{moment(item.registration_date).format('MM-DD-YYYY')}</span>
                                <span class="desig">Registration Deadline</span>
                            </div>
                        </div>
                        
                        <div class="col-md-3">
                            <div class="list-action-wrpr text-right roundicons-text">
                                <Link to={"/exhibition_register/"+item.id} data-toggle="tooltip" title="Exhibitors"  style={{marginRight:'10px'}}><i style={{background:'rgb(174, 94, 186)'}} data-count={item?.exhibition_registrations.length} class="edit icon-user2 data-counts-icon"></i><span>&nbsp;&nbsp;Exhibitors&nbsp;&nbsp;</span></Link>
                                <Link to={"/view_exhibition/"+item.id} data-toggle="tooltip" title="View"  ><i style={{background:'rgb(255, 87, 127)'}} class="edit icon-eye"></i><span>View</span></Link>
                                {
                                    item.publish === 'UNPUBLISHED'?
                                    ( 
                                        <a onClick={()=>{statusChange(item.id)}} data-toggle="tooltip" title="Publish"  ><i style={{background:'rgb(94, 186, 125)'}} class="edit icon-publish"></i><span>&nbsp;&nbsp;Publish&nbsp;&nbsp;</span></a>
                                    ) :
                                    (
                                        <a onClick={()=>{statusChange(item.id)}} data-toggle="tooltip" title="Published" ><i style={{background:'rgb(94, 186, 125)'}} class="edit icon-tick"></i><span>Published</span></a>
                                    )
                                }
                            </div>
                        </div>

                    </div>

                    
                </div>
                )):null
                }
                {
                    !exhibitiontList?
                    (<div className="nodata">
                        <h2>Sorry! No Result Found</h2>
                    </div>):null
 
                }

                {exhibitiontList?
                    <div class="number-of footer-number">
					    Displaying 1-{counts} of {totalItems} results.
				    </div>:null
                }
                        
     
            </div>    
            { 
                loader?
                <div>
                    <div className="loader_container"><Loader/></div>
                </div>
                :
                null
            }
                {exhibitiontList?
                <div class="pagination-wrpr">
                    <ReactPaginate
                            className="pagination page"
                            pageClassName="page-item"
                            activeClassName="active"
                            nextLabel=">"
                            previousLabel="<"
                            previousClassName="page-link p-link"
                            nextClassName="page-link p-link"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={10}
                            pageCount={totalPages}
                            renderOnZeroPageCount={1}
                            // selected page
                            initialPage={page?page-1:0}
                        />
                </div>:null
                }


        </div>
        </aside>
    </div>
    );
}

export default Exhibitionlist;


